import { render, staticRenderFns } from "./DonationView.vue?vue&type=template&id=46de3f20&scoped=true"
import script from "./DonationView.vue?vue&type=script&lang=js"
export * from "./DonationView.vue?vue&type=script&lang=js"
import style0 from "./DonationView.vue?vue&type=style&index=0&id=46de3f20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46de3f20",
  null
  
)

export default component.exports